<template>
    <div>
      <q-card class="my-card">
        <q-card-section>
          <div class="row col-12" style="margin-bottom: 10px;">
            <div class="col-9 container-app">
              <div class="row title-row">
                <div class="title">Datos de la Entidad</div>
              </div>
              <div class="input-row">
                <q-input
                  data-cy="name-Entidad"
                  v-model="v$.name.$model"
                  outlined
                  debounce="1000"
                  :error="v$.name.$error"
                  label="*Nombre Entidad"
                  counter
                  maxlength="255"
                  class="col-12"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
            </div>
          </div>
          <div class="row col-12" style="margin-bottom: 10px;">
            <div class="col-9 container-app">
              <div class="input-row">
                <q-input
                  data-cy="indicatorTitle-Entidad"
                  v-model="v$.titleIndicator.$model"
                  outlined
                  debounce="1000"
                  :error="v$.titleIndicator.$error"
                  label="*Título Mis Indicadores"
                  counter
                  maxlength="255"
                  class="col-12"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-9 container-app">
              <div class="input-row">
                <q-input
                  data-cy="serviceTitle-Entidad"
                  v-model="v$.titleService.$model"
                  outlined
                  debounce="1000"
                  :error="v$.titleService.$error"
                  label="*Título Mis Servicios Digitales"
                  counter
                  maxlength="255"
                  class="col-12"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
              <div>
                <q-toggle
                  data-cy="toggle-visible-Entidad"
                  color="primary"
                  v-model="visible"
                  label="Entidad visible"
                  left-label
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Validation from '@/components/shared/mixins/Validation.js';
import Message from '@/components/shared/mixins/Message.js';
import Formats from '@/components/shared/mixins/Formats.js';
import Resources from '@/components/shared/mixins/Resources.js';
import { QToggle } from 'quasar';

export default {
  components: { QToggle },
  setup: () => ({ v$: useVuelidate() }),
  mixins: [Validation, Message, Formats, Resources],
  validations: {
    name: { required },
    titleIndicator: { required },
    titleService: { required }
  },
  props: {
    dataEntidad: Object,
    dataServicios: Object,
    isNew: Boolean
  },
  data () {
    return {
      serviciosEntidad: this.serviciosEntidad,
      idEntidad: null,
      name: null,
      titleIndicator: null,
      titleService: null,
      visible: false,
      events: {
        saveServicios: 'EJECUCION_GUARDAR_SERVS'
      }
    };
  },
  mounted () {
    this.$eventHub.$on(
      'APLICACION_ACTUALIZAR_INFORMACION',
      ({ callback, rejected }) => this.saveValues(callback, rejected)
    );

    this.$eventHub.$on('HAVE_ERROR', () => this.checkToSave());
  },
  beforeDestroy () {
    this.$eventHub.$off('APLICACION_ACTUALIZAR_INFORMACION');
  },
  methods: {
    async saveValues (callback, rejected) {
      let result = {
        data: null,
        status: false
      };
      this.v$.$touch();
      if (!this.v$.$error) {
        let dataArray = {
          name: this.name,
          titleIndicator: this.titleIndicator,
          titleService: this.titleService,
          visible: this.visible
        };
        if (this.isNew) {
          result = await this.saveNewApp(dataArray);
        } else {
          result = await this.saveUpdates(dataArray);
        }

        if (result.status) {
          callback(result);
        } else {
          rejected(result);
        }
      } else {
        let response = {
          data: null,
          status: false
        };
        rejected(response);
      }
    },
    async saveNewApp (dataArray) {
      let request = {
        controller: '/Entidad/',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.idEntidad = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });

      return responseData;
    },
    async saveUpdates (dataArray) {
      this.serviciosEntidad.name = dataArray.name;
      this.serviciosEntidad.visible = dataArray.visible;
      this.serviciosEntidad.titleIndicator = dataArray.titleIndicator;
      this.serviciosEntidad.titleService = dataArray.titleService;
      return {
        data: this.serviciosEntidad,
        status: true
      };
    },
    async refillData () {
      this.name = this.serviciosEntidad.hasOwnProperty('name') ? this.serviciosEntidad.name : null;
      this.visible = this.serviciosEntidad.hasOwnProperty('visible') ? this.serviciosEntidad.visible : false;
      this.idEntidad = this.serviciosEntidad.hasOwnProperty('id') ? this.serviciosEntidad.id : null;
      this.titleIndicator = this.serviciosEntidad.hasOwnProperty('titleIndicator') ? this.serviciosEntidad.titleIndicator : null;
      this.titleService = this.serviciosEntidad.hasOwnProperty('titleService') ? this.serviciosEntidad.titleService : null;
    }
  },
  watch: {
    dataEntidad: {
      handler: function () {
        this.serviciosEntidad = this.dataEntidad;
        if (Object.entries(this.dataEntidad).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>
